import { Button, Modal, Input, Form, message } from "antd";
import React, { useState, useEffect } from "react";
import APICaller from "../../../utils/APICaller";
import { Table } from "antd";
import "./internalErrorRca.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import { useContext } from "react";
import moment from "moment";
import { JsonToExcel } from "react-json-to-excel";
import BeforeTableHeader from "../../layouts/beforeTableHeader";
import "react-datetime/css/react-datetime.css";

import HandleSearch from "../../../utils/CommonSearchComponent";
import { exportJson } from "../../../utils/export";

import CustomLoader from "../../common/customLoader";
import DownloadAllModal from "../audits/downloadAllModal";

const InternalErrorRca = ({ children }) => {
  let errorRaiseDate = null;
  let erroronweekdayweekend = null;
  let dayoftheweek = null;
  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const slsLIUId = secureLocalStorage.getItem("lIUId");
  const slsReportingSupervisor = secureLocalStorage.getItem(
    "reportingSupervisor"
  );
  const [isInternalErrorRcaModalVisible, setIsInternalErrorRcaModalVisible] =
    useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [selectedAudit, setSelectedAudit] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  {
    /*Declaring states*/
  }

  const [selectionType, setSelectionType] = useState("checkbox");
  const [searchData, setSearchData] = useState([]),
    [selectedRowsArray, setSelectedRowsArray] = useState([]);

  const [list, setList] = useState([]);
  const [listItems, setListItems] = useState([]);

  const [showLoader, setShowLoader] = useState(true);
  const [allTransactionIdsArr, setAllTransactionIdsArr] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false),
    [visible, setVisible] = useState(false),
    [isModalVisible, setIsModalVisible] = useState(false),
    [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  {
    /*Fetch the list of Audits*/
  }
  const [pagination, setPagination] = useState({ current: 1, pageSize: 100 });

  const getInternalErrorRcaList = async (source = "", pagination = "") => {
    const allKeys = Object.keys(localStorage);
    let removeItems;
    switch (secureLocalStorage.getItem("fromComponent")) {
      case "audits": {
        removeItems = [
          "@secure.n.totalAuditedCount",
          "@secure.s.auditScore",
          "@secure.j.parameterSelectedList",
          "@secure.j.auditFormInput",
          "@secure.s.auditFormCall",
          "@secure.n.auditedQuestionScoreCount",
          "@secure.n.auditedQuestionCount",
          "@secure.j.countMap",
          "@secure.s.clickedLink",
          "@secure.j.timeStampsDetails",
          "@secure.n.weightageFlag",
          "@secure.j.updatedQMF",
          "@secure.s.savedAuditId",
          "@secure.b.auditedFormSubmit",
          "@secure.s.aID",
          "@secure.j.savePayloadRequestParams",
        ];
        break;
      }
      default: {
        break;
      }
    }
    allKeys &&
      allKeys.forEach((key) => {
        if (removeItems && removeItems.includes(key)) {
          localStorage.removeItem(key);
        }
      });

    let hasSearchedValue, searchKeyword;
    if (secureLocalStorage.getItem("hasSearchedValue")) {
      hasSearchedValue = "yes";
      searchKeyword = secureLocalStorage.getItem("searchKeyword");
    } else {
      hasSearchedValue = "";
      searchKeyword = "";
    }
    const searchIn = "internal-error-rca";
    const callActionFrom = source ? source : "";
    const globalStates = {
      globalState: globalState,
      setGlobalState: setGlobalState,
    };
    const { current, pageSize } = pagination;

    setSelectedRowKeys([]);
    const allStates = {
      searchData: searchData,
      setSearchData: setSearchData,
      selectedRowsArray: selectedRowsArray,
      setSelectedRowsArray: setSelectedRowsArray,
      showLoader: showLoader,
      setShowLoader: setShowLoader,
      pagination: pagination
        ? pagination
        : { current: 1, page: 1, pageSize: 100 },
      setPagination: setPagination,
      list: list,
      setList: setList,
      listItems,
      setListItems,
      allTransactionIdsArr: allTransactionIdsArr,
      setAllTransactionIdsArr: setAllTransactionIdsArr,
    };

    await HandleSearch(
      hasSearchedValue,
      searchIn,
      searchKeyword,
      callActionFrom,
      globalStates,
      allStates
    );
  };

  const handleOk = () => {
    let submitFormModal = "";
    if (isInternalErrorRcaModalVisible === true) {
      submitFormModal = "clickedOK";
    }

    const lIUId = secureLocalStorage.getItem("lIUId");

    if (
      globalState?.eErrorRaiseDateVal &&
      globalState?.eFeedbackdate &&
      globalState?.eErrorDescription &&
      globalState?.eErrorImpact &&
      globalState?.eErrorStatus &&
      globalState?.eAdvisorShiftDuringError &&
      globalState?.eErroronweekdayweekendVal &&
      globalState?.eDayoftheweekVal &&
      globalState?.eAgentTenure &&
      globalState?.eFeedbackStatus &&
      globalState?.eFeedbackShared &&
      globalState?.eRepeatedError &&
      globalState?.eCorrectiveActionTaken &&
      globalState?.ePreventiveActionTaken &&
      globalState?.eErrorcorrected &&
      globalState?.eErrorArea &&
      globalState?.eErrorType &&
      globalState?.rcaLevelOneVal &&
      globalState?.rcaLevelTwoVal &&
      globalState?.rcaLevelThreeVal &&
      globalState?.rcaLevelFourVal
    ) {
      let eFeedbackdate = moment(globalState?.eFeedbackdateVal).format(
        "YYYY-MM-DD"
      );
      let createdAt = new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      let createdBy = lIUId;
      let status = "ACTIVE";

      if (submitFormModal === "clickedOK") {
        setIsModalOpen(false);
        setIsModalVisible(false);
        setVisible(false);
        const endpoint = `/internal-error-rca`;
        const method = "POST";

        const payload = {
          auditID: globalState?.auditID,
          errorRaiseDate: selectedAudit
            ? getErrorRaiseDate(selectedAudit?.createdAt)
            : null,

          feedbackdate: eFeedbackdate,
          errorDescription: globalState?.eErrorDescription,
          errorImpact: globalState?.eErrorImpact,
          errorInvestigationRemarks: globalState?.eErrorInvestigationRemarks,
          errorStatus: globalState?.eErrorStatus,
          advisorShiftDuringError: globalState?.eAdvisorShiftDuringError,
          erroronweekdayweekend: selectedAudit
            ? getErrorWeekdayWeekend(selectedAudit?.transaction_date)
            : null,
          dayoftheweek: selectedAudit
            ? getDayoftheweek(selectedAudit?.transaction_date)
            : null,
          agentTenure: globalState?.eAgentTenure,
          feedbackStatus: globalState?.eFeedbackStatus,
          feedbackShared: globalState?.eFeedbackShared,
          repeatedError: globalState?.eRepeatedError,
          correctiveActionTaken: globalState?.eCorrectiveActionTaken,
          preventiveActionTaken: globalState?.ePreventiveActionTaken,
          errorcorrected: globalState?.eErrorcorrected,
          valueoflossprevented: globalState?.eValueoflossprevented,
          errorArea: globalState?.eErrorArea,
          errorType: globalState?.eErrorType,
          rcaLevelOne: globalState?.rcaLevelOneVal,
          rcaLevelTwo: globalState?.rcaLevelTwoVal,
          rcaLevelThree: globalState?.rcaLevelThreeVal,
          rcaLevelFour: globalState?.rcaLevelFourVal,
          status,
          createdAt,
          createdBy,
        };

        APICaller(slsRole, slsToken, endpoint, method, payload)
          .then((response) => {
            message.success("Added successfully");
            navigate("/escalations/internal-error-rca");
          })
          .catch((error) => {});
      } else {
        setIsModalOpen(true);
        setIsModalVisible(true);
      }
    } else {
      setIsModalOpen(true);

      setGlobalState((prevGlobalState) => ({
        ...prevGlobalState,
        eErrorRaiseDate: globalState?.eErrorRaiseDateVal
          ? globalState?.eErrorRaiseDateVal
          : "Error raise date is required",
        eFeedbackdate: globalState?.eFeedbackdateVal
          ? globalState?.eFeedbackdateVal
          : "Feedback date is required",
        eErrorDescription: globalState?.eErrorDescriptionVal
          ? globalState?.eErrorDescriptionVal
          : "Error description is required",
        eErrorImpact: globalState?.eErrorImpactVal
          ? globalState?.eErrorImpactVal
          : "Error impact is required",
        eErrorStatus: globalState?.eErrorStatusVal
          ? globalState?.eErrorStatusVal
          : "Error status is required",
        eAdvisorShiftDuringError: globalState?.eAdvisorShiftDuringErrorVal
          ? globalState?.eAdvisorShiftDuringErrorVal
          : "Advisor shift during error is required",
        eErroronweekdayweekend: globalState?.eErroronweekdayweekendVal
          ? globalState?.eErroronweekdayweekendVal
          : "Error on Weekday/Weekend is required",
        eDayoftheweek: globalState?.eDayoftheweekVal
          ? globalState?.eDayoftheweekVal
          : "Day of the week is required",
        eAgentTenure: globalState?.eAgentTenureVal
          ? globalState?.eAgentTenureVal
          : "Agent tenure is required",
        eFeedbackStatus: globalState?.eFeedbackStatusVal
          ? globalState?.eFeedbackStatusVal
          : "Feedback status is required",
        eFeedbackShared: globalState?.eFeedbackSharedVal
          ? globalState?.eFeedbackSharedVal
          : "Feedback shared in how many hrs after accepting error is required",
        eRepeatedError: globalState?.eRepeatedErrorVal
          ? globalState?.eRepeatedErrorVal
          : "Repeated error is required",
        eCorrectiveActionTaken: globalState?.eCorrectiveActionTakenVal
          ? globalState?.eCorrectiveActionTakenVal
          : "Corrective action taken is required",

        ePreventiveActionTaken: globalState?.ePreventiveActionTakenVal
          ? globalState?.ePreventiveActionTakenVal
          : "Preventive action taken (Action Plan) is required",

        eErrorcorrected: globalState?.eErrorcorrectedVal
          ? globalState?.eErrorcorrectedVal
          : "Error corrected in the system is required",

        eErrorArea: globalState?.eErrorAreaVal
          ? globalState?.eErrorAreaVal
          : "Error Area is required",
        eErrorType: globalState?.eErrorTypeVal
          ? globalState?.eErrorTypeVal
          : "Error Type is required",
        rcaLevelOne: globalState?.rcaLevelOneVal
          ? globalState?.rcaLevelOneVal
          : "RCA Level One is required",
        rcaLevelTwo: globalState?.rcaLevelTwoVal
          ? globalState?.rcaLevelTwoVal
          : "RCA Level Two is required",
        rcaLevelThree: globalState?.rcaLevelThreeVal
          ? globalState?.rcaLevelThreeVal
          : "RCA Level Three is required",
        rcaLevelFour: globalState?.rcaLevelFourVal
          ? globalState?.rcaLevelFourVal
          : "RCA Level Four is required",
      }));
    }
  };

  const handleCancel = () => {
    setIsInternalErrorRcaModalVisible(false);
  };

  {
    /*Export functionality on Audit Listing's table clicking on checkboxes*/
  }
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  {
    /*Calling audit detail page on its ID's click*/
  }
  const handleAuditDetailClickedLink = () => {
    secureLocalStorage.setItem("clickedLink", "auditsDetailLinkClick");
    secureLocalStorage.setItem("fromComponent", "audits");
  };
  const exportColumns = [
    { key: "Form", path: "auditForm.formName" },
    { key: "Department", path: "department.name" },
    { key: "Client Name", path: "client.name" },
    { key: "Agent Emp Code", path: "agent.empID" },
    { key: "Agent Name", path: "agent.name" },
    { key: "Auditor Name", path: "auditor.name" },
    { key: "Insured Name", path: "insuredName" },
    { key: "Transaction ID", path: "transaction_id" },
    { key: "Quality Score", path: "score" },
    {
      key: "Maximum Possible Score",
      path: "auditedScoreInfo",
      formatter: (value) =>
        value ? JSON.parse(value).auditedMaxQuestionCount : "",
    },
    {
      key: "Actual Score",
      path: "auditedScoreInfo",
      formatter: (value) =>
        value ? JSON.parse(value).auditedQuestionCount : "",
    },
    {
      key: "Audit Date",
      path: "createdAt",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    {
      key: "Transaction Date",
      path: "transactionDate",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    {
      key: "Error Raise Date",
      path: "internalerrorrcaID.errorRaiseDate",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    {
      key: "Feedback Date",
      path: "internalerrorrcaID.feedbackdate",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    { key: "Reporting Supervisor", path: "agentReportingSupervisor.name" },
    { key: "Error Description", path: "internalerrorrcaID.errorDescription" },
    { key: "Error Impact", path: "internalerrorrcaID.errorImpact" },
    {
      key: "Error Investigation Remarks",
      path: "internalerrorrcaID.errorInvestigationRemarks",
    },
    { key: "Error Status", path: "internalerrorrcaID.errorStatus" },
    {
      key: "Advisor Shift During Error",
      path: "internalerrorrcaID.advisorShiftDuringError",
    },
    {
      key: "Error on Weekday/Weekend",
      path: "internalerrorrcaID.erroronweekdayweekend",
    },
    { key: "Day of the week", path: "internalerrorrcaID.dayoftheweek" },
    { key: "Advisor Tenure", path: "internalerrorrcaID.agentTenure" },
    { key: "Feedback Status", path: "internalerrorrcaID.feedbackStatus" },
    {
      key: "Feedback shared in how many hrs after accepting error",
      path: "internalerrorrcaID.feedbackShared",
    },
    {
      key: "Repeated Error",
      path: "internalerrorrcaID.repeatedError",
    },
    {
      key: "Corrective Action Taken",
      path: "internalerrorrcaID.correctiveActionTaken",
    },
    {
      key: "Preventive Action Taken (Action Plan)",
      path: "internalerrorrcaID.preventiveActionTaken",
    },
    {
      key: "Error corrected in the system",
      path: "internalerrorrcaID.errorcorrected",
    },
    {
      key: "$ value of Loss prevented",
      path: "internalerrorrcaID.valueoflossprevented",
    },
    {
      key: "Error Area",
      path: "internalerrorrcaID.errorArea",
    },
    {
      key: "Error Type",
      path: "internalerrorrcaID.errorType",
    },
    {
      key: "Root Cause Analysis - L1",
      path: "internalerrorrcaID.rcaLevelOne",
    },
    {
      key: "Root Cause Analysis - L2",
      path: "internalerrorrcaID.rcaLevelTwo",
    },
    {
      key: "Root Cause Analysis - L3",
      path: "internalerrorrcaID.rcaLevelThree",
    },
    {
      key: "Root Cause Analysis - L4",
      path: "internalerrorrcaID.rcaLevelFour",
    },
  ];
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);

      exportJson(
        selectedRows,
        globalState?.internalErrorRcaLists,
        "InternalErrorRcaReport",
        exportColumns,
        setGlobalState,
        globalState
      );
    },
  };

  const getErrorRaiseDate = (dateString) => {
    if (!dateString) return null;

    // Expected format: DD-MM-YY hh:mm AM/PM
    const [datePart, timePart, meridian] = dateString.split(" ");
    const [day, month, year] = datePart.split("-").map(Number);
    let [hours, minutes] = timePart.split(":").map(Number);

    // Adjust hours for AM/PM
    if (meridian?.toUpperCase() === "PM" && hours < 12) {
      hours += 12;
    } else if (meridian?.toUpperCase() === "AM" && hours === 12) {
      hours = 0;
    }

    // Fix year (25 → 2025, 99 → 2099, etc.)
    const fullYear = year < 100 ? 2000 + year : year;

    // Format YYYY-MM-DD
    const yyyy = fullYear;
    const mm = String(month).padStart(2, "0");
    const dd = String(day).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  const getErrorWeekdayWeekend = (dateString) => {
    if (!dateString) return null;

    const date = new Date(dateString);
    const day = date.getDay();

    return day === 0 || day === 6 ? "Weekend" : "Weekday";
  };
  const getDayoftheweek = (dateString) => {
    if (!dateString) return null;

    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { weekday: "short" });
  };

  {
    /*Defining columns for Audit Listing*/
  }
  const columns = [
    {
      title: () => {
        return <div className="tableTitle">AUDIT ID</div>;
      },
      dataIndex: "id",
      width: "10",
      render: (text, row) => {
        // Log row object to console
        return (
          <Link
            to={"/audits/" + row.id}
            state={{
              route: location.pathname,
              auditFormHasWeightage: row.hasWeightage,
              formMethd: row.formMethd,
              process: row.process?._id,
            }}
            style={{ color: "black" }}
          >
            <span
              className="rowstyle"
              style={{ color: "#1875CB" }}
              onClick={handleAuditDetailClickedLink}
            >
              {text}
            </span>
          </Link>
        );
      },
    },
    {
      title: () => {
        return <div className="tableTitle">Form</div>;
      },
      dataIndex: "form",
      width: "10",
      render: (text, row) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle">Transaction ID</div>;
      },
      dataIndex: "transaction_id",
      width: "10",
      render: (text) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle">Auditor</div>;
      },
      dataIndex: "auditor",
      width: "10",
      render: (text) => <span className="rowstyle">{text?.name}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle">Agent</div>;
      },
      dataIndex: "agent",
      width: "10",
      render: (text) => <span className="rowstyle">{text?.name}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle"> Score</div>;
      },
      dataIndex: "score",
      width: "10",
      render: (text, row) => <span className="rowstyle">{text}%</span>,
    },
    {
      title: () => {
        return <div className="tableTitle">Created At</div>;
      },
      dataIndex: "createdAt",
      width: "10",
      render: (text, row) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle">RCA</div>;
      },
      dataIndex: "id",
      render: (text, row) => {
        const handleAddClick = () => {
          setGlobalState((prevGlobalState) => {
            return {
              ...prevGlobalState,

              eAdvisorShiftDuringError: null,
              eAdvisorShiftDuringErrorVal: null,

              eErrorRaiseDate: null,
              eErrorRaiseDateVal: null,

              eFeedbackdate: null,
              eFeedbackdateVal: null,

              eErrorDescription: null,
              eErrorDescriptionVal: null,

              eErrorImpact: null,
              eErrorImpactVal: null,

              eErrorInvestigationRemarks: null,
              eErrorInvestigationRemarksVal: null,

              eErrorStatus: null,
              eErrorStatusVal: null,

              eAdvisorShiftDuringError: null,
              eAdvisorShiftDuringErrorVal: null,

              eErroronweekdayweekend: null,
              eErroronweekdayweekendVal: null,

              eDayoftheweek: null,
              eDayoftheweekVal: null,

              eAgentTenure: null,
              eAgentTenureVal: null,

              eFeedbackStatus: null,
              eFeedbackStatusVal: null,

              eFeedbackShared: null,
              eFeedbackSharedVal: null,

              eRepeatedError: null,
              eRepeatedErrorVal: null,

              eCorrectiveActionTaken: null,
              eCorrectiveActionTakenVal: null,

              ePreventiveActionTaken: null,
              ePreventiveActionTakenVal: null,

              eErrorcorrected: null,
              eErrorcorrectedVal: null,

              eValueoflossprevented: null,
              eValueoflosspreventedVal: null,

              eErrorArea: null,
              eErrorAreaVal: null,

              eErrorType: null,
              eErrorTypeVal: null,

              rcaLevelOne: null,
              rcaLevelOneVal: null,

              rcaLevelTwo: null,
              rcaLevelTwoVal: null,

              rcaLevelThree: null,
              rcaLevelThreeVal: null,

              rcaLevelFour: null,
              rcaLevelFourVal: null,
            };
          });
          setSelectedAudit(row);

          setIsViewMode(false);
          setIsInternalErrorRcaModalVisible(true);
        };
        // Log row object to console
        return (
          <>
            {row.internalerrorrcaID ? (
              <Link
                to={"/escalations/internal-error-rca/" + row.id}
                state={{
                  route: location.pathname,
                  auditFormHasWeightage: row.hasWeightage,
                  formMethd: row.formMethd,
                  process: row.process?._id,
                }}
                style={{ color: "black" }}
              >
                <span className="rowstyle previewBy">
                  {text ? <span>View</span> : ""}
                </span>
              </Link>
            ) : (
              <Button type="link" onClick={handleAddClick}>
                Add
              </Button>
            )}
          </>
        );
      },
    },
  ];

  useEffect(() => {
    getInternalErrorRcaList();
  }, []);

  /*Audit Date*/
  var today = moment();
  var valid = function (current) {
    return current.isBefore(today);
  };

  /*Audit Date*/

  const [backAuditDateChecked, setBackAuditDateChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setBackAuditDateChecked(e.target.checked);
  };

  const [form] = Form.useForm();

  {
    /*begin:: Download all audits*/
  }
  const onCreateDownloadAll = async (values) => {
    secureLocalStorage.setItem("isActiveLoad", "activeLoad");
    const month = values?.month.format("YYYY-MM");

    try {
      let hasSearchedValue, searchKeyword;
      if (secureLocalStorage.getItem("hasSearchedValue")) {
        hasSearchedValue = "yes";
        searchKeyword = secureLocalStorage.getItem("searchKeyword");
      } else {
        hasSearchedValue = "";
        searchKeyword = "";
      }

      const endpoint = "/downloadAll";
      const method = "POST";
      const payload = {
        role: secureLocalStorage.getItem("role"),
        lIUId: secureLocalStorage.getItem("lIUId"),
        searchKeyword: searchKeyword,
        month: month,
        exportOf: "audit_internalRca",
        exportColumns: exportColumns,
      };

      const response = await APICaller(
        slsRole,
        slsToken,
        endpoint,
        method,
        payload,
        "blob"
      );

      // Check if the response data is a Blob
      if (response instanceof Blob) {
        // Create a Blob from the response
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a link element
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "internal-error-rca.xlsx";

        // Append to the DOM
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Revoke the Blob URL after the download
        window.URL.revokeObjectURL(link.href);

        // Clean up
        document.body.removeChild(link);

        message.success("Download done successfully");
        setIsDownloadModalOpen(false);
        secureLocalStorage.setItem("isActiveLoad", "");
      } else {
        console.error("Expected a Blob, but got:", response);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleDownloadAll = async () => {
    secureLocalStorage.setItem("isActiveLoad", "false");
    setIsDownloadModalOpen(true);
  };

  {
    /*end: Download all audits*/
  }

  const isAdmin = secureLocalStorage.getItem("role") === "admin";
  const isAuditor = secureLocalStorage.getItem("role") === "auditor";
  const isQC = secureLocalStorage.getItem("role") === "qc";

  const hasSelectedRows =
    globalState.selectedRowKeysChildInfo &&
    globalState.selectedRowKeysChildInfo.length > 0;

  return (
    <>
      <div className="all-content internalErrRca">
        <div className="d-flex">
          <BeforeTableHeader list={listItems} showListingCount="yes" href="" />
          <div className="right-buttons">
            {(isAdmin || isAuditor) && (
              <>
                {/*Download as Excel*/}
                {hasSelectedRows && (
                  <JsonToExcel
                    title="Download as Excel"
                    data={globalState.exportInternalErrorRcaReportJson}
                    fileName="internalErrorRcaReport"
                    btnClassName="table-buttons"
                  />
                )}
              </>
            )}
            {(isAdmin || isAuditor) && (
              <div className="downloadAllLoader-container">
                <span className="" onClick={handleDownloadAll}>
                  Download All
                </span>

                <DownloadAllModal
                  open={isDownloadModalOpen}
                  setVisible={setIsDownloadModalOpen}
                  onCreate={onCreateDownloadAll}
                />
              </div>
            )}
            {(isAdmin || isAuditor) && (
              <>
                {/* // This modal will reuse your form for both Add and View */}
                <Modal
                  className="all-modal"
                  onCancel={handleCancel}
                  onOk={handleOk}
                  title={
                    <div className="headermodaltitle">
                      Add Internal Error RCA
                    </div>
                  }
                  open={isInternalErrorRcaModalVisible}
                  bodyStyle={{ height: "70vh", overflowY: "scroll" }}
                  footer={[
                    <Button
                      key="back"
                      className="submit-btn border-0 rounded"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>,
                    <Button
                      key="submit"
                      className="submit-btn border-0 rounded"
                      onClick={handleOk}
                    >
                      Create
                    </Button>,
                  ]}
                  width={"50vw"}
                >
                  {children &&
                    React.cloneElement(children, {
                      selectedAudit,
                      errorRaiseDate: selectedAudit
                        ? getErrorRaiseDate(selectedAudit?.createdAt)
                        : null,
                      erroronweekdayweekend: selectedAudit
                        ? getErrorWeekdayWeekend(
                            selectedAudit?.transaction_date
                          )
                        : null,
                      dayoftheweek: selectedAudit
                        ? getDayoftheweek(selectedAudit?.transaction_date)
                        : null,
                    })}
                </Modal>
              </>
            )}
          </div>
        </div>
        <div className="all-table-holder">
          <CustomLoader showLoader={showLoader} />
          <Table
            rowSelection={{
              type: selectionType,
              ...rowSelection,
            }}
            columns={columns}
            dataSource={globalState.internalRcalist}
            pagination={globalState?.pagination}
            onChange={(e) => {
              getInternalErrorRcaList("pagination", e);
            }}
          />
        </div>
      </div>
    </>
  );
};
export default InternalErrorRca;
